import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { Card, Col, Row, Tabs, Typography } from "antd";
import TabPane from "antd/es/tabs/TabPane";

import ApiConfigTabContent from "js/components/Organization/ApiConfigTabContent";
import { ApiData } from "js/components/Organization/types";

import { useGetAdvisorApiKeys } from "../../../hooks/useOrganizations";

const { Title } = Typography;

const ApiUsersConfig = () => {
  const { organizationData } = useSelector(
    (state) => state.entities.organization,
  );

  const { data: apiKeysData, isLoading } = useGetAdvisorApiKeys();

  // Compute API data objects from hook data
  const expressData = useMemo<ApiData>(() => {
    if (!apiKeysData?.api_express) {
      return { url: "", docs: "", users: [] };
    }
    return {
      url: import.meta.env.VITE_APP_EXPRESS_API_URL,
      docs: import.meta.env.VITE_APP_EXPRESS_API_DOCS_URL,
      users: apiKeysData.api_express,
    };
  }, [apiKeysData]);

  const sicData = useMemo<ApiData>(() => {
    if (!apiKeysData?.api_sic) {
      return { url: "", docs: "", users: [] };
    }
    return {
      url: import.meta.env.VITE_APP_SIC_API_URL,
      docs: import.meta.env.VITE_APP_SIC_API_DOCS_URL,
      users: apiKeysData.api_sic,
    };
  }, [apiKeysData]);

  const multireportData = useMemo<ApiData>(() => {
    if (!apiKeysData?.api_multireporte) {
      return { url: "", docs: "", users: [] };
    }
    return {
      url: import.meta.env.VITE_APP_MULTIREPORT_API_URL,
      docs: import.meta.env.VITE_APP_MULTIREPORT_API_DOCS_URL,
      users: apiKeysData.api_multireporte,
    };
  }, [apiKeysData]);

  // Compute default tab based on priority: multireport > sic > express
  const defaultTab = useMemo<string | null>(() => {
    if (apiKeysData?.api_multireporte) return "tab3";
    if (apiKeysData?.api_sic) return "tab2";
    if (apiKeysData?.api_express) return "tab1";
    return null;
  }, [apiKeysData]);

  // Active tab state (user can switch tabs)
  const [activeTab, setActiveTab] = useState<string | null>(null);

  return (
    <>
      <Title>Integración API</Title>
      <Row justify="center">
        <Col xs={24} sm={24} md={18} lg={18} xl={18} span={18}>
          <Card loading={isLoading}>
            <Tabs
              activeKey={activeTab ?? defaultTab ?? "tab1"}
              onTabClick={(key) => setActiveTab(key)}
            >
              {organizationData &&
              organizationData.view_api_express_menu_option ? (
                <TabPane tab="EXPRESS API" key="tab1">
                  <ApiConfigTabContent data={expressData} apiId={"express"} />
                </TabPane>
              ) : (
                <TabPane tab="EXPRESS API" key="tab1" disabled={true}></TabPane>
              )}
              {organizationData && organizationData.view_api_sic_menu_option ? (
                <TabPane tab="SIC API" key="tab2">
                  <ApiConfigTabContent data={sicData} apiId={"sic"} />
                </TabPane>
              ) : (
                <TabPane tab="SIC API" key="tab2" disabled={true}></TabPane>
              )}

              {organizationData &&
              organizationData.view_api_multireport_menu_option ? (
                <TabPane tab="MULTIREPORT API" key="tab3">
                  <ApiConfigTabContent
                    data={multireportData}
                    apiId={"multireport"}
                  />
                </TabPane>
              ) : (
                <TabPane
                  tab="MULTIREPORT API"
                  key="tab3"
                  disabled={true}
                ></TabPane>
              )}
            </Tabs>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ApiUsersConfig;
